import PhotoSwipeLightbox from 'photoswipe/lightbox';

export default (el) => {
    const lightbox = new PhotoSwipeLightbox({
        gallery: el,
        children: 'a[data-pswp-src]',
        pswpModule: () => import('photoswipe'),
        // Enterprise animations
        showHideAnimationType: 'zoom',
        initialZoomLevel: 'fit',
        secondaryZoomLevel: 2,
        maxZoomLevel: 4,
    });

    // Caption Plugin (Enterprise Level)
    lightbox.on('uiRegister', function() {
        lightbox.pswp.ui.registerElement({
            name: 'custom-caption',
            order: 9,
            isOrigin: false,
            render: (el) => {
                lightbox.pswp.on('change', () => {
                    const currSlideElement = lightbox.pswp.currSlide.data.element;
                    let captionHTML = '';
                    if (currSlideElement) {
                        const img = currSlideElement.querySelector('img');
                        captionHTML = img ? img.getAttribute('alt') : '';
                    }
                    el.innerHTML = captionHTML || '';
                });
            }
        });
    });

    lightbox.init();
};
